module.exports = __webpack_public_path__ + "images/a780f4d.png";